import { useEffect, useState } from 'react';

import { AuthService } from 'shared/lib/keycloak';
import { useGetWalkthroughStatusQuery } from 'shared/api/client-state';

export const useWalkthroughStatus = () => {
  const userBk = AuthService.getUserBk();

  const { data: walkthroughStatus, isLoading } =
    useGetWalkthroughStatusQuery(userBk);

  const [isWalkthroughCompleted, setIsWalkthroughCompleted] = useState(true);

  useEffect(() => {
    if (isLoading) return;

    if (walkthroughStatus && walkthroughStatus.isWalkthroughCompleted) {
      setIsWalkthroughCompleted(true);

      return;
    }

    setIsWalkthroughCompleted(false);
  }, [walkthroughStatus, isLoading]);

  return isWalkthroughCompleted;
};
